import { useContext } from 'react';
import { Route as RouterRoute, Redirect } from 'react-router-dom';

import { AuthContext } from '../context/Auth/AuthContext';

const Route = ({
  component: Component,
  render,
  isPrivate = false,
  isPublic = false,
  allowedProfiles,
  ...rest
}) => {
  const { isAuth, loading, user } = useContext(AuthContext);

  const hasAllowedProfile = () => {
    if (!Array.isArray(allowedProfiles) || allowedProfiles.length === 0) return true;
    const profile = (user?.profile || '').toLowerCase();
    const normalizedAllowed = allowedProfiles.map((p) => String(p).toLowerCase());
    if (normalizedAllowed.includes(profile)) return true;
    if (user?.super && normalizedAllowed.includes('superadmin')) return true;
    return false;
  };

  // Rotas públicas (landing, login, cadastro, etc) - carrega instantaneamente sem loading
  if (isPublic) {
    if (
      !loading &&
      isAuth &&
      (rest.path === '/' ||
        rest.path === '/login' ||
        rest.path === '/signup' ||
        rest.path === '/cadastro')
    ) {
      return (
        <Redirect to={{ pathname: '/tickets/conversation', state: { from: rest.location } }} />
      );
    }
    return <RouterRoute {...rest} component={render ? undefined : Component} render={render} />;
  }

  // Rotas privadas: splash só existe no index.html (primeira carga). Aqui não usa componente.
  if (loading) {
    return null;
  }

  if (!isAuth && isPrivate) {
    return <Redirect to={{ pathname: '/login', state: { from: rest.location } }} />;
  }

  if (!isAuth && !isPrivate) {
    return <Redirect to={{ pathname: '/login', state: { from: rest.location } }} />;
  }

  if (isPrivate && !hasAllowedProfile()) {
    return <Redirect to={{ pathname: '/tickets/conversation', state: { from: rest.location } }} />;
  }

  return <RouterRoute {...rest} component={render ? undefined : Component} render={render} />;
};

export default Route;
